import { useQuery } from "@tanstack/react-query";
import { APIErrorResponse } from "src/types/generic";
import apiClient from "../apiClient";

export type TaxReportColumn = {
  branch_id: number | null;
  name: string | number;
  column_scope: "branch" | "company" | "total" | string;
};

export type TaxReportRow = {
  key: string;
  label: string;
  amounts: number[];
  is_bold: boolean;
  row_type: "line" | "header";
};

// The tax report is sourced from journal entries. Its columns/date filters
// mirror the profit-and-loss report, but the body is a flat list of rows
// (no nested sections / summary block).
export type TaxReportJournalPayload = {
  start_date: string;
  end_date: string;
  branch_id: number | null;
  columns: TaxReportColumn[];
  rows: TaxReportRow[];
};

interface ITaxReportJournalParams {
  start_date: string;
  end_date: string;
  branch_id?: number;
  enabled?: boolean;
}

export const useGetTaxReportJournalData = (params: ITaxReportJournalParams) =>
  useQuery<any, APIErrorResponse, { data: TaxReportJournalPayload }>({
    queryKey: [
      "get-tax-report-journal-data",
      params.start_date,
      params.end_date,
      params.branch_id,
      params.enabled ?? true,
    ],
    queryFn: async () => {
      const searchParams = new URLSearchParams();
      searchParams.set("start_date", params.start_date);
      searchParams.set("end_date", params.end_date);
      if (params.branch_id != null) {
        searchParams.set("branch_id", String(params.branch_id));
      }
      return apiClient.get(`/api/reports/tax?${searchParams.toString()}`);
    },
    enabled: params.enabled !== false,
    gcTime: 0,
  });
